<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <CompanyForm v-if="company" :company="company" />
      <LoadingPage v-if="!company"/>
    </PageRowWrapper>

  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import CompanyForm from '@/components/settings/users/company/CompanyForm'
import LoadingPage from '@/components/spinner/LoadingPage'

export default {
  name: 'CompanyEdit',
  components: {
    PageTitle,
    PageRowWrapper,
    CompanyForm,
    LoadingPage
  },
  computed: {
    ...mapState({
      company: state => state.company.companyById
    })
  },
  methods: {
    ...mapActions('company', ['fetchById'])
  },
  mounted () {
    this.fetchById(this.$route.params.id)
  }
}
</script>
